export default __webpack_public_path__ + "static/teambuilding-c6c1d49f5bc91e830d72363949af0c6e.jpg";